import script from "./HeatmapPrecios.vue?vue&type=script&setup=true&lang=js"
export * from "./HeatmapPrecios.vue?vue&type=script&setup=true&lang=js"

import "./HeatmapPrecios.vue?vue&type=style&index=0&id=e3166b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3166b68"]])

export default __exports__